/** @jsx jsx */
import { ClassNames, css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ValuePropItem } from '@coursera-web/cds-labs';
import { MODULE_LAYOUTS, ValuePropsModule } from '@coursera-web/cds-labs';

import { breakpoints } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';

export type PayingForYourDegreeModuleProps = {
  heading: string;
  description?: string | null;
  stats: ValuePropItem[];
  items: ValuePropItem[];
};

const styles = {
  extraPaddingCard: css`
    margin-top: var(--cds-spacing-150);
    padding: var(--cds-spacing-400) var(--cds-spacing-800) !important;

    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-50);
      padding: var(--cds-spacing-200) var(--cds-spacing-400) !important;
    }
  `,
  zeroPaddingCard: css`
    padding: 0 !important;
    margin-top: var(--cds-spacing-200);
  `,
  zeroPaddingLayout: css`
    && {
      padding: 0;
    }
  `,
  hideEmptyDiv: css`
    div:empty {
      display: none;
    }
  `,
};

const PayingForYourDegreeModule = ({ heading, description, stats, items }: PayingForYourDegreeModuleProps) => (
  <ClassNames>
    {({ css: cx }) => (
      <React.Fragment>
        <ValuePropsModule
          headline={heading}
          description={description ? <Markdown source={description} /> : null}
          valueProps={stats}
          layout={MODULE_LAYOUTS.textTopImageBottom}
          cardBackgroundColor="var(--cds-color-neutral-background-primary)"
          cardClassName={cx(styles.extraPaddingCard)}
          customPageContainerStyles={[styles.zeroPaddingLayout]}
        />
        <div css={styles.hideEmptyDiv}>
          <ValuePropsModule
            valueProps={items}
            layout={MODULE_LAYOUTS.textTopImageBottom}
            cardBackgroundColor="transparent"
            cardClassName={cx(styles.zeroPaddingCard)}
            customPageContainerStyles={[styles.zeroPaddingLayout]}
          />
        </div>
      </React.Fragment>
    )}
  </ClassNames>
);

export default PayingForYourDegreeModule;
